import { useCalibration } from '../../../context/calibrationContext';
import { usePostMessage } from '../../../context/messageContext';
import { Icon } from '../../../component-library';
import { Button, Text, Flex, theme } from '../../../2022-component-library/src';
import { useMediaQuery } from '../../../helpers/useMediaQuery';
import { useEffect, useState } from 'react';

const ResponsiveCalibrationSelectionContainer = ({ setActiveTab }) => {
  const [showResponsiveViewAlert, setShowResponsiveViewAlert] = useState(false);
  const smallScreen = useMediaQuery('(max-width: 600px)');
  const postMessage = usePostMessage();
  const {
    calibrationData: { screenCalibrated, cameraCalibrated, patientUsingResponsiveView },
  } = useCalibration();

  useEffect(() => {
    if (patientUsingResponsiveView) return setShowResponsiveViewAlert(true);
  }, [patientUsingResponsiveView]);

  const selectCalibrationType = (selection) => {
    postMessage({ type: selection });
    return setActiveTab(selection);
  };

  const CalibrationOption = ({ option, calibrated }) => {
    const titleCaseOption = option.charAt(0).toUpperCase() + option.slice(1);
    return (
      <Flex column centered>
        <Flex
          centered
          backgroundColor={calibrated ? theme.colors.success : theme.colors.neutralLight}
          height='150px'
          width='200px'
          borderRadius='4px'
          boxShadow='0px 3px 15px rgba(0, 0, 0, 0.2)'
        >
          <Icon icon={option === 'screen' ? 'display' : 'camera'} size={50} color='#fff' marginTop='0.5rem' />
        </Flex>
        <Flex marginTop='1rem'>
          <Text fontWeight='bold'>{`${titleCaseOption}:\u00a0`}</Text>
          <Text>{calibrated ? 'Calibrated Successfully' : 'Not Calibrated'}</Text>
        </Flex>
        <Button
          marginTop={smallScreen ? '1rem' : '2rem'}
          marginBottom={smallScreen ? '2rem' : null}
          fontFamily='Plus Jakarta Sans'
          fontSize='1rem'
          onClick={() => selectCalibrationType(`${option}-calibration`)}
        >
          {calibrated ? 'Recalibrate' : 'Calibrate Now'}
        </Button>
      </Flex>
    );
  };

  return (
    <Flex column centered>
      {showResponsiveViewAlert && (
        <Text
          fontWeight='bold'
          color={theme.colors.error}
          marginBottom='1rem'
        >{`Note: Patient appears to be using a smaller screen such as a mobile phone or tablet.`}</Text>
      )}
      <Flex
        width='100vw'
        maxWidth='680px'
        flexDirection={smallScreen ? 'column' : 'row'}
        justifyContent='space-around'
        marginBottom='min(7.5vh, 2rem)'
      >
        <CalibrationOption option='screen' calibrated={screenCalibrated} />
        <CalibrationOption option='camera' calibrated={cameraCalibrated} />
      </Flex>
      <Button
        width='15em'
        backgroundColor={theme.colors.success}
        style={{ visibility: screenCalibrated && cameraCalibrated ? 'visible' : 'hidden' }}
        onClick={() => setActiveTab('set-distance')}
      >{`NEXT`}</Button>
    </Flex>
  );
};

export default ResponsiveCalibrationSelectionContainer;
